export default __webpack_public_path__ + "images/Tapclicks.5a2daf5991a74518fd3885cae7b14b8a.svg";